import * as React from 'react'
import Avatar from 'components/Avatar'
import { format } from 'utils/date'

export default function ReplyCard({ reply }) {
  return (
    <div style={{ backgroundColor: '#F9F9F9', padding: '16px 10px' }}>
      <Avatar user={reply.responder} />
      <p>{reply.content}</p>
      <span style={{ fontSize: 12, color: '#4F5B62' }}>
        {format(reply.createdAt)}
      </span>
    </div>
  )
}
